<script setup>
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
</script>

<template>
  <!-- Snackbar: messaggi brevi -->
  <VSnackbar
    v-model="ui.snackbarVisible"
    :color="ui.snackbarColor"
    timeout="3000"
  >
    {{ ui.snackbarMessage }}
    <template #actions>
      <VBtn
        text
        @click="ui.snackbarVisible = false"
      >
        Chiudi
      </VBtn>
    </template>
  </VSnackbar>

  <!-- Alert persistente (es. errori globali) -->
  <VAlert
    v-if="ui.errorMessage"
    type="error"
    class="ma-4"
    border="start"
    prominent
  >
    {{ ui.errorMessage }}
  </VAlert>

  <!-- Dialog/Modal per avvisi importanti -->
  <VDialog
    v-model="ui.alertVisible"
    max-width="400"
  >
    <VCard>
      <VCardTitle>{{ ui.alertType.toUpperCase() }}</VCardTitle>
      <VCardText>{{ ui.alertMessage }}</VCardText>
      <VCardActions>
        <VBtn
          text
          @click="ui.alertVisible = false"
        >
          Chiudi
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
